import GET_ARTICLES from '../plugins/getArticles'

const [ w, d ] = [ window, document ]

const init = () => {}

const documentLoaded = () => {
  $.when( w.load['recruit-welfare'] ).then( (data, slot) => {
    $('[data-slot="recruit-welfare"]').html( slot )
  })
  $.when( w.load['recruit-treat'] ).then( (data, slot) => {
    $('[data-slot="recruit-treat"]').html( slot )
  })
  $.when( w.load['recruit-qa'] ).then( (data, slot) => {
    $('[data-slot="qa-list"]').html( slot )
  })

  const midCareer = d.querySelector('.recruit-news');
  if(midCareer){
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <figure class="block-news-item__img">
            <div class="block-news-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220" loading="lazy"></div>
          </figure>
          <div class="block-news-item__body">
            <span class="cate">${item.category.name}</span>
            <span class="date">${item.date}</span>
            ${item.is_new ? '<span class="is-new">NEW</span>': ''}
            <span class="subject">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem });
  };
}

export default function RECRUIT () {
  $( init )
  $( documentLoaded )
}